<!--
    日期时间选择器
    jetty 2018.09

    @param
        value:[],
        timeType:           默认控制显示/隐藏 也可传string锁定类型
        timeTypeOptions:    时间类型选项
        disabled:           是否禁用
        pickedRange:        选中时间范围
        popedRange:         剔除时间范围

    @return [start_time,end_time]

    @event @timeType="pickedTimeType"

-->
<template>
    <div class="timePicker">
        <div class="dateTimePicker">
            <DatePicker @on-change="change" :value="pickedTime" :options="options" :disabled="disabled" format="yyyy-MM-dd HH:mm" type="datetimerange" placeholder="Select date"></DatePicker>
            <i class="iconfont iconBlue">&#xe630;</i>
        </div>
    </div>
</template>
<script>
    import {check, array} from '@/utils/'
    import moment from 'moment'

    export default {
        name: 'TimePicker',
        props: {
            value: {
                type: [Array, Number],
                default: () => {
                    return []
                }
            },
            config: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            defaultPicked: { // 默认选定时间范围
                type: String,
                default: 'today'
            },
            defaultPoped: { // 默认例外取值范围
                type: Array,
                default: () => {
                    return ['yesterday']
                }
            }
        },
        data () {
            return {
                formatFull: 'YYYY-MM-DD HH:mm:ss',
                formatShort: 'YYYY-MM-DD',
                defaultEndTime: {hour: 23, minute: 59, second: 59},
                defaultStartTime: {hour: 0, minute: 0, second: 0},
                pickedTime: this.value,
                options: {
                    disabledDate: (date) => { // 禁止选择的时间段，默认只能选择历史时间
                        if (this.config.picked && this.config.picked == 'yesterday') {
                            return date && date.valueOf() >= new Date() - 86400000
                        }
                        return date && date.valueOf() >= new Date()
                    },
                    shortcuts: [ // 时间范围快速可配置项
                        {text: '今天', key: 'today', value: () => { this.changeTimeRange('today') }},
                        {text: '昨天', key: 'yesterday', value: () => { this.changeTimeRange('yesterday') }},
                        {text: '最近一周', key: 'week', value: () => { this.changeTimeRange('week') }},
                        {text: '最近一月', key: '1month', value: () => { this.changeTimeRange('1month') }},
                        {text: '最近三月', key: '3month', value: () => { this.changeTimeRange('3month') }},
                        // {text: '自定义', value: () => { this.changeTimeRange('custom') }},
                    ]
                }
            }
        },
        computed: {
        },
        created () {
            if (this.config.poped) {
                this.config.poped.forEach((it) => { // 移除时间范围
                    array.deleteItemByKey(this.options.shortcuts, 'key', it)
                })
            } else {
                this.defaultPoped.forEach((it) => { // 移除时间范围
                    array.deleteItemByKey(this.options.shortcuts, 'key', it)
                })
            }
            if (check.isEmptyArray(this.pickedTime)) {
                this.init()
            }
        },
        methods: {
            init () {
                if (this.config.picked) {
                    this.changeTimeRange(this.config.picked)
                } else {
                    this.changeTimeRange(this.defaultPicked)
                }
            },
            /**
             * 修改当前选中时间(外部赋值也用此方法)
             * @param
             * event = [startTime, endTime]
             * */
            change (event) {
                if (check.isArray(event) && !check.isNull(event[0])) {
                    this.formatTime(event)
                    this.timeChanged()
                } else {
                    this.$emit('on-change', undefined)
                }
            },
            initDay () {
                if (this.config.picked != 'yesterday') {
                    this.pickedTime = [moment().set(this.defaultStartTime).format(this.formatFull), moment().set(this.defaultEndTime).format(this.formatFull)]
                } else {
                    this.pickedTime = [moment().subtract(1, 'days').set(this.defaultStartTime).format(this.formatFull), moment().subtract(1, 'days').set(this.defaultEndTime).format(this.formatFull)]
                }
            },
            formatTime (event) { // 格式化时间，结束时间当天最大，时间精确到分
                if (moment(event[1]).add(23, 'hours').format(this.formatShort) != moment(event[1]).format(this.formatShort)) {
                    event[1] = moment(event[1]).set({second: 59}).format(this.formatFull)
                } else {
                    event[1] = moment(event[1]).set(this.defaultEndTime).format(this.formatFull)
                }
                event[0] = moment(event[0]).format(this.formatFull)
                this.pickedTime = event
            },
            changeTimeRange (type) { // 修改快捷时间选择项，并修改对应时间
                if (type != 'custom') {
                    this.initDay()
                }
                switch (type) {
                    case 'week':
                        this.pickedTime[0] = moment(this.pickedTime[0]).subtract(7, 'days').format(this.formatFull)
                        break
                    case '1month':
                        this.pickedTime[0] = moment(this.pickedTime[0]).subtract(1, 'month').format(this.formatFull)
                        break
                    case '3month':
                        this.pickedTime[0] = moment(this.pickedTime[0]).subtract(3, 'month').format(this.formatFull)
                        break
                    case 'custom':
                        return
                }
                this.timeChanged()
            },
            timeChanged () {
                this.$emit('on-change', this.pickedTime)
            }
        },
        watch: {
            value (val) {
                if (val === '') { // 潜规则
                    this.pickedTime = []
                    return
                }
                if (!check.isNull(val) && val !== this.pickedTime) {
                    this.pickedTime = val
                }
            }
        }
    }
</script>
<style lang="less">
    .timePicker {
        .dateTimePicker {
            .ivu-date-picker-rel {
                .ivu-input-wrapper {
                    i.ivu-icon {
                        display: none
                    }
                    .ivu-input {
                        width: 268px;
                    }
                }
            }
        }
        .dataTimeSelect {
            width: 100px;
        }
        .dateTimePicker {
            position: relative;
            display: inline-block;
            width: 268px;
        }
        i.iconfont {
            position: absolute;
            right: 5px;
            font-size: 22px;
            top: 0px;
        }
    }
</style>
